import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { InputBase, List, ListItem, Box, Button } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import useStyles from './index.style';
import { getLoadFilter, getLoads, updateLoadFilter } from 'redux/actions/Loads';
import { Search } from '@material-ui/icons';

const LoadSearch = ({ handleSearch, handleClear }) => {
  const classes = useStyles();
  const { currentLoadFilter } = useSelector(({ loadsReducer }) => loadsReducer);
  const [searchText, setSearchText] = useState('');

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      // console.log('enter press here! ');
      handleSearch(searchText);
      if (!searchText && !searchText.length) {
        handleClear();
      }
    }
  };

  useEffect(() => {
    if (currentLoadFilter && currentLoadFilter.unique_load_id) {
      setSearchText(currentLoadFilter.unique_load_id);
    }
  }, [currentLoadFilter]);

  return (
    <Box className={classes.filterWrapper + ' filterWrapper'}>
      <List className={classes.filterList + ' listInline'}>
        <ListItem className="listInlineItem">
          <List className={classes.innerFilterList + ' listInline'}>
            <ListItem className="listInlineItem" style={{ minWidth: '300px' }}>
              <Box className={classes.searchRoot}>
                <InputBase
                  placeholder={'Search By Load Number'}
                  inputProps={{ 'aria-label': 'search' }}
                  value={searchText}
                  onChange={e => setSearchText(e.target.value)}
                  onKeyDown={handleKeyDown}
                />
                <Search />
              </Box>
            </ListItem>
            <ListItem className="listInlineItem">
              <Button
                size="small"
                variant="contained"
                style={{ fontSize: 12 }}
                color="primary"
                onClick={() => {
                  handleSearch(searchText);
                }}>
                Search
              </Button>
            </ListItem>
            <ListItem className="listInlineItem">
              <Button
                size="small"
                variant="outlined"
                style={{ fontSize: 12 }}
                color="primary"
                onClick={() => {
                  handleClear();
                  setSearchText('');
                }}>
                Clear
              </Button>
            </ListItem>
          </List>
        </ListItem>
        {/* <ListItem className={classes.sortListItem + ' listInlineItem'}>
                {filter != '' ? <React.Fragment>{filter()}</React.Fragment> : null}
            </ListItem> */}
      </List>
    </Box>
  );
};

LoadSearch.propTypes = {
  filterOptions: PropTypes.object,
  setFilterOptions: PropTypes.func,
};

export default React.memo(LoadSearch);
